import '../../common/css/style.css';

// • Чому обирають саме нас — коротко про переваги студії
// • Факти тут повторюють те, що вже сказано в розділах "Про студію" і "Викладачі"

const REASONS = [
  {
    icon: '🏆',
    title: 'Тренери-чемпіони',
    text: 'Наш дует — чемпіони, призери та фіналісти змагань міжнародного і всеукраїнського рівня.',
  },
  {
    icon: '🎓',
    title: 'Професійна освіта',
    text: 'Вища хореографічна освіта, випускники Харківської державної академії культури.',
  },
  {
    icon: '💛',
    title: 'Тепла атмосфера',
    text: 'Навчаємо з любовʼю — цінуємо щирість, наполегливість і повагу одне до одного.',
  },
  {
    icon: '📍',
    title: 'Зручне розташування',
    text: 'Студія у Голосіївському районі Києва — легко дістатися з будь-якої точки міста.',
  },
];

export const WhyUs = () => {
  return (
    <div id="why-us" className="main-style">
      <div className="whyus-wrapper">
        <h2 className="container-title">Чому обирають нас</h2>

        <div className="whyus-grid">
          {REASONS.map(({ icon, title, text }) => (
            <div className="whyus-card" key={title}>
              <span className="whyus-icon" aria-hidden="true">
                {icon}
              </span>
              <h3 className="whyus-title">{title}</h3>
              <p>{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
